<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1>Blog details</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Blog Details</li>
      </ol>
    </nav>
  </div>
</section>
<!-- Inner Banner End -->
<!-- Start Blog Detail Area -->
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-12">

        <div class="blog-single">
          <div class="card blog--card">
            <figure>
              <a href=""><img src="assets/images/blog/1.jpg" class="img-fluid" alt=""></a>
              <figcaption>
                <a href=""><i class="mdi mdi-image-outline"></i></a>
              </figcaption>
            </figure>
            <div class="card-body">
              <h5><a href="">dolor sit amet, consectetur adipisicing elit,</a></h5>
              <ul class="post-meta d-flex">
                <li>Mar 12, 2020</li>
                <li>by <a href="">Tomillo</a></li>
                <li>in <a href="">Event</a></li>
                <li><a href="">6 Comments</a></li>
              </ul>
              <p class="m-0">is simply dummy text of the printing and typesetting industry. has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p><br />
              <p class="m-0">is simply dummy text of the printing and typesetting industry. has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p><br />
              <p class="m-0">is simply dummy text of the printing and typesetting industry. has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p><br />
              <p class="m-0">is simply dummy text of the printing and typesetting industry. has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="sidebar">
          <!-- search widget -->
          <div class="widget-wrapper">
            <div class="search-widget">
              <form action="#">
                <div class="input-group">
                  <input type="text" placeholder="Search">
                  <button type="submit"><i class="mdi mdi-24px mdi-magnify"></i></button>
                </div>
              </form>
            </div>
          </div>
          <!-- category widget -->
          <div class="widget-wrapper">
            <div class="widget-default">
              <div class="widget-header">
                <h6 class="widget-title">Categories</h6>
              </div>
              <div class="widget-content">
                <div class="category-widget">
                  <ul>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Business</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Finance</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Industry Reports</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Strategy</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Technology</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Marketing</a></li>
                    <li><a href=""><i class="mdi mdi-chevron-right mdi-18px mr-1"></i>Strategy</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- popular post -->
          <div class="widget-wrapper">
            <div class="widget-default">
              <div class="widget-header">
                <h6 class="widget-title">Recent Post</h6>
              </div>
              <div class="widget-content">
                <div class="sidebar-post">
                  <div class="post-single">
                    <div class="d-flex align-items-center">
                      <a href=""><img src="assets/images/blog/thumb1.jpg" alt=""></a>
                      <p><span>Jan 25, 2018</span> <span>by <a href="">Tomillo</a></span></p>
                    </div>
                    <a href="" class="post-title">dolor sit amet, consectetur adipisicing.</a>
                  </div>
                  <div class="post-single">
                    <div class="d-flex align-items-center">
                      <a href=""><img src="assets/images/blog/thumb1.jpg" alt=""></a>
                      <p><span>Jan 25, 2018</span> <span>by <a href="">Tomillo</a></span></p>
                    </div>
                    <a href="" class="post-title">dolor sit amet, consectetur adipisicing.</a>
                  </div>
                  <div class="post-single">
                    <div class="d-flex align-items-center">
                      <a href=""><img src="assets/images/blog/thumb1.jpg" alt=""></a>
                      <p><span>Jan 25, 2018</span> <span>by <a href="">Tomillo</a></span></p>
                    </div>
                    <a href="" class="post-title">dolor sit amet, consectetur adipisicing.</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tags -->
          <div class="widget-wrapper">
            <div class="widget-default">
              <div class="widget-header">
                <h6 class="widget-title">Popular Tags</h6>
              </div>
              <div class="widget-content">
                <div class="tags-widget">
                  <ul>
                    <li><a href="">Business</a></li>
                    <li><a href="">Finance</a></li>
                    <li><a href="">Strategy</a></li>
                    <li><a href="">Global</a></li>
                    <li><a href="">Marketing</a></li>
                    <li><a href="">Technology</a></li>
                    <li><a href="">Wordpress</a></li>
                    <li><a href="">Solution</a></li>
                    <li><a href="">Bizillion</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Blog Detail Area -->
